import { all } from "redux-saga/effects";
import getListNotification from "./getListNotification";
import getNotificationDetail from "./getNotificationDetail";
import getTotalNotification from "./getTotalNotification";
import postWatchedNotification from "./postWatchedNotification";

export const notificationPageSaga = function* root() {
	yield all([
		getListNotification(),
		getNotificationDetail(),
		getTotalNotification(),
		postWatchedNotification()
	]);
};
